import React, { useState } from 'react'
import { Button, Input, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { Spell, SpellAssignment } from '../../redux/models'
import { useAppDispatch } from '../../redux/redux-hooks'
import { ModalsActions } from '../../redux/slices/modals-slice'
import { secondsToTimestamp } from '../../util/time-utils'
import { LabeledInput } from './LabeledInput'

export const EXPORT_ERT_TIMESTAMPS_MODAL = "EXPORT_ERT_TIMESTAMPS_MODAL"

export type ExportErtTimestampsProps = {
    actorName: string
    spell: Spell
    assignments: SpellAssignment[]
}

export const ExportErtTimestamps = (props: ExportErtTimestampsProps): JSX.Element | null => {

    const appDisp = useAppDispatch()
    const closeSelf = () => appDisp(ModalsActions.popModal())

    const [name, setName] = useState(props.actorName)
    const [spellName, setSpellName] = useState(props.spell.name)
    const [spellId, setSpellId] = useState(2)

    const content = props.assignments.reduce<string>((acc, curr) => {
        acc += `{time:${secondsToTimestamp(curr.offset)}} ${spellName} {spell:${spellId}} ${name}\n`

        return acc
    }, '')

    return (
        <Modal
            isOpen={true}
            fade={false}
            size="lg"
            toggle={closeSelf}
        >
            <ModalBody>
                <div className="mb-3 p-3 rounded border bg-light small">
                    {`Paste this into your personal ERT note to use it with a WA like `}

                    <a href="https://wago.io/n7l5uN3YM" target="_blank" rel="noreferrer">
                        {'https://wago.io/n7l5uN3YM.'}
                    </a>

                    {' '}
                    {`Make sure the name matches yours or the keyword you're using. Remember to grab`}
                    {' '}
                    {`all assignments. This is just for one spell.`}

                    <br />
                    <br />

                    {`There are currently no spell-ids in the system, so they're all using a dummy ID of 2.`}
                    {` `}
                    {`This won't affect the WA, but you won't get a pretty icon. You can replace them manually if you want.`}

                    <br />
                    <br />

                    {`Also note that these timers are NOT dynamic. If a fight has dynamic phasing, these timers will start to drift.`}
                </div>

                <div className="d-flex mb-3 space-mx-3">
                    <LabeledInput
                        className={"flex-grow-1"}
                        label={'Actor name'}
                        inputProps={{
                            value: name,
                            onChange: (e) => {
                                setName(e.target.value)
                            },
                            onBlur: (e) => {
                                if (e.target.value === '') {
                                    setName(props.actorName)
                                }
                            }
                        }}
                    />
                    <LabeledInput
                        className={"flex-grow-1"}
                        label={'Spell name'}
                        inputProps={{
                            value: spellName,
                            onChange: (e) => {
                                setSpellName(e.target.value)
                            },
                            onBlur: (e) => {
                                if (e.target.value === '') {
                                    setSpellName(props.spell.name)
                                }
                            }
                        }}
                    />
                    <LabeledInput
                        className={"flex-grow-1"}
                        label={'Spell id'}
                        inputProps={{
                            type: 'number',
                            value: spellId,
                            onChange: (e) => {
                                setSpellId(parseInt(e.target.value))
                            },
                            onBlur: (e) => {
                                if (e.target.value === '') {
                                    setSpellId(2)
                                }
                            }
                        }}
                    />
                </div>

                <Input
                    className="text-monospace small"
                    readOnly
                    style={{
                        minHeight: 500
                    }}
                    value={content}
                    type="textarea"
                />
            </ModalBody>

            <ModalFooter className="d-flex justify-content-end">
                <div className="d-flex space-mx-2">
                    <Button onClick={closeSelf}>
                        {"Cancel"}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}